module.exports = __webpack_public_path__ + "static/img/BANNER_MDT_ETPA2.384afae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BANNER_MDT_ETPA2.jpg
// module id = SAZ4
// module chunks = 1